import React from 'react';
import { PlusCircleFilled } from '@ant-design/icons';
import classnames from 'classnames';
import styles from './style.module.scss';

interface ThumbnailListProps {
  images: string[];
  onClick: () => void;
  onClickFirstThumbnail?: () => void;
}

const ThumbnailList: React.FC<ThumbnailListProps> = ({
  images,
  onClick,
  onClickFirstThumbnail
}) => {
  const maxThumbnails = 4;
  const placeholders = Array(maxThumbnails - images.length).fill(null);

  return (
    <div className="flex space-x-[-10px]">
      {images.slice(0, maxThumbnails).map((image, index) => (
        <div
          key={image}
          className={classnames(
            'cursor-pointer w-20 h-28 bg-cover bg-center rounded-lg shadow-md',
            styles.thumbnail,
            {
              [styles['thumbnail--hover']]: index === 0
            }
          )}
          style={{
            background: `url(${image}) lightgray 50% / cover no-repeat`
          }}
          onClick={() => (index === 0 ? onClickFirstThumbnail() : onClick())}
        >
          {index === 0 && (
            <div className="cursor-pointer flex items-center justify-center w-full h-full opacity-50 rounded-lg">
              <PlusCircleFilled
                className={classnames(
                  'text-white text-3xl',
                  styles['plus--icon']
                )}
              />
            </div>
          )}
        </div>
      ))}
      {placeholders.map((image, index) => (
        <div
          key={`placeholder-${image}`}
          className={classnames(
            'cursor-pointer w-20 h-28 bg-cover bg-center rounded-lg shadow-md',
            styles.thumbnail,
            {
              [styles['thumbnail--hover']]: index === 0 && images.length === 0
            }
          )}
          onClick={() =>
            index === 0 && images.length === 0
              ? onClickFirstThumbnail()
              : onClick()
          }
        >
          {index === 0 && images.length === 0 && (
            <div className="cursor-pointer flex items-center justify-center w-full h-full opacity-50 rounded-lg">
              <PlusCircleFilled
                className={classnames(
                  'text-white text-3xl',
                  styles['plus--icon']
                )}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ThumbnailList;
